// extracted by mini-css-extract-plugin
module.exports = {"notifications-area":"notifications_notifications-area__StCaF","toast":"notifications_toast__3uHtc","progress":"notifications_progress__8MZBP"};